import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import {
  UPDATE_CLIENTNOTE_FAILURE,
  UPDATE_CLIENTNOTE_REQUEST,
  UPDATE_CLIENTNOTE_SUCCESS
} from "../types";
import { addEntities } from "../../entities";
import awsImageUpload from "../../../helpers/awsImageUpload";

export default (factoringId, noteId, note, attachment) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(UPDATE_CLIENTNOTE_REQUEST)({}));

    let filename = [];
    if (attachment && attachment.name) {
      filename = [{ filename: attachment.name }];
    }

    const response = await api.factoring.updateFactoringClientNote(
      factoringId,
      noteId,
      note,
      filename
    );

    if (attachment && attachment.name) {
      await awsImageUpload(
        [attachment].map(attachment => ({
          file: attachment,
          upload_url: response.attachments[0].upload_url
        }))
      );
    }

    const data = normalize(response, schema.clientNote);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(UPDATE_CLIENTNOTE_SUCCESS)({
        [factoringId]: [data.result]
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(UPDATE_CLIENTNOTE_FAILURE)(err));
    throw err;
  }
};
